import React from 'react'
import _ from 'underscore'
import { Book, Calendar, CircleAlert, CircleHelp, Handshake, Info, Languages, Laptop, Megaphone, Square, SquareCheck, Star, User, Wrench, Zap } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import PillSelect from '../../../pill_select'
import DateSelect from '../../../date_select'
import Modal from '../../../modal'
import ClientAvailability from '../client_availability'
import JobReadiness from '../job_readiness'
import TutorResults from '../../tutoring_job/tutor_search/results/index'
import store from '../../../../state/store'

const CURRICULUM_OPTIONS = ['CAPS', 'IEB', 'Cambridge', 'NSC']

class LessonPlanTutors extends React.Component {

  state = {
    curriculumOther: false,
    jobAdConfirmOpen: false
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.lesson_plan !== this.props.lesson_plan)
      return true

    if (nextProps.enquiry_id !== this.props.enquiry_id)
      return true

    if (nextProps.tutor_results !== this.props.tutor_results)
      return true

    if (nextProps.tutor_proposals !== this.props.tutor_proposals)
      return true

    if (nextProps.google_map_ui !== this.props.google_map_ui)
      return true

    if (nextProps.ui !== this.props.ui)
      return true

    if (nextState !== this.state)
      return true

    return false
  }

  onMediumChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {medium: value}
    )
  }

  onTutorGenderChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {tutor_gender: value || 'any'}
    )
  }

  onAdvertisedChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {advertised: value}
    )
  }

  onJobAdToggleClick = () => {
    if (this.props.lesson_plan.tutoring_job.advertised) {
      this.onAdvertisedChange(false)
    } else {
      this.setState({jobAdConfirmOpen: true})
    }
  }

  onJobAdConfirm = () => {
    this.setState({jobAdConfirmOpen: false})
    this.onAdvertisedChange(true)
  }

  onJobAdCancel = () => {
    this.setState({jobAdConfirmOpen: false})
  }

  onStartDateChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {start_date: value}
    )
  }

  onCommitmentChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {commitment: value}
    )
  }

  onCurriculumChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {curriculum: value}
    )
    this.setState({curriculumOther: false})
  }

  onCurriculumSelectChange = (value) => {
    if (value === '_other') {
      this.setState({curriculumOther: true})
    } else {
      this.onCurriculumChange(value)
    }
  }

  getCurriculumSelectValue = () => {
    return this.props.lesson_plan.tutoring_job.curriculum || ''
  }

  getCurriculumOptions = () => {
    const current = this.props.lesson_plan.tutoring_job.curriculum || ''
    const options = CURRICULUM_OPTIONS.map((o) => ({value: o, name: o + ' Syllabus'}))
    if (current && !CURRICULUM_OPTIONS.includes(current)) {
      options.push({value: current, name: current + ' Syllabus'})
    }
    options.push({value: '_other', name: 'Other'})
    return options
  }

  onLanguageChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {language_id: value}
    )
  }

  onChallengeChange = (value) => {
    store.emit('tutoring_jobs:update_settings', this.props.lesson_plan.tutoring_job.id, {challenge: value})
  }

  onUrgencyChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {urgency: value}
    )
  }

  onTutorTierChange = (value) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id,
      {tutor_tier: value || 'any'}
    )
  }


  render() {
    const lesson_plan = this.props.lesson_plan

    const commitmentOptions = [
      { value: 'one_month', name: '1 month commitment' },
      { value: 'two_months', name: '2 months commitment' },
      { value: 'three_months', name: '3 months commitment' },
      { value: 'four_months', name: '4 months commitment' },
      { value: 'five_months', name: '5 months commitment' },
      { value: 'six_months', name: '6 months commitment' },
      { value: 'seven_months', name: '7 months commitment' },
      { value: 'eight_months', name: '8 months commitment' },
      { value: 'nine_months', name: '9 months commitment' },
      { value: 'ten_months', name: '10 months commitment' },
      { value: 'eleven_months', name: '11 months commitment' },
      { value: 'twelve_months', name: '12 months commitment' },
      { value: 'ongoing', name: 'Ongoing commitment' },
      { value: 'please_advise_me', name: 'Please advise me' },
      { value: '1_to_3_months', name: '1 – 3 months commitment' },
      { value: '3_to_6_months', name: '3 – 6 months commitment' },
      { value: 'six_plus_months', name: '6+ months commitment' },
      { value: 'twelve_plus_months', name: '12+ months commitment' },
    ]

    const languageOptions = _.map(lesson_plan.languages, function (language) {
      return {
        name: language.name + ' speaking',
        value: language.id
      }
    })

    const challengeOptions = [
      {value: 'fundamental_gaps', name: 'Fundamental gaps'},
      {value: 'problem_areas', name: 'Problem areas'},
      {value: 'immediate_help', name: 'Exam / test help'}
    ]
    const challengeDisplay = {
      fundamental_gaps: 'Challenge: fundamental gaps',
      problem_areas: 'Challenge: problem areas',
      immediate_help: 'Challenge: exam / test help'
    }

    const urgencyOptions = [
      {value: 'asap', name: 'ASAP'},
      {value: 'this_week', name: 'This week'},
      {value: 'this_month', name: 'This month'},
      {value: 'later', name: 'Later'}
    ]
    const urgencyDisplay = {
      asap: 'Urgent: ASAP',
      this_week: 'Urgent: this week',
      this_month: 'Urgent: this month',
      later: 'Not in a rush'
    }

    const tutorTierOptions = [
      {value: 'any', name: 'Any tier'},
      {value: 'top_tier', name: 'Top tier'}
    ]

    return (
      <React.Fragment>
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Megaphone className="size-4"/>
              Job Ad
            </CardTitle>
            <CardAction className="ml-auto self-center">
              <Button
                variant="outline"
                size="sm"
                onClick={this.onJobAdToggleClick}
                className={
                  lesson_plan.tutoring_job.advertised
                    ? 'border-transparent bg-success font-semibold text-success-foreground hover:bg-success/90 hover:text-success-foreground'
                    : 'border-warning bg-warning/15 font-semibold text-foreground hover:bg-warning/25'
                }
              >
                {lesson_plan.tutoring_job.advertised ? <SquareCheck strokeWidth={2.5} className="size-4.5"/> : <Square strokeWidth={2.5} className="size-4.5"/>}
                {lesson_plan.tutoring_job.advertised ? 'Job ad ON' : 'Job ad OFF'}
              </Button>
            </CardAction>
          </CardHeader>
          <CardContent className="flex flex-col gap-4">
            <div>
              <span className="inline-flex items-center rounded-full bg-muted px-3.5 py-1.5 text-[13px] text-muted-foreground">
                <Info className="mr-2 size-3.5"/>
                These choices affect both the job ad and search results.
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              <PillSelect
                icon={Laptop}
                options={[{value: 'local', name: 'Face-to-face lessons'}, {value: 'online', name: 'Online lessons'}]}
                value={lesson_plan.medium}
                placeholder="Select Lesson Medium"
                onChange={this.onMediumChange}
              />
              <PillSelect
                icon={User}
                options={[{value: 'any', name: 'Any gender'}, {value: 'female', name: 'Female tutor'}, {value: 'male', name: 'Male tutor'}]}
                value={lesson_plan.tutor_gender}
                placeholder="Tutor gender..."
                onChange={this.onTutorGenderChange}
              />
              <PillSelect
                icon={Languages}
                options={languageOptions}
                value={lesson_plan.tutoring_job.language_id}
                placeholder="Language..."
                onChange={this.onLanguageChange}
              />
              <PillSelect
                icon={Star}
                options={tutorTierOptions}
                value={lesson_plan.tutoring_job.tutor_tier}
                placeholder="Tutor tier..."
                onChange={this.onTutorTierChange}
                footer={
                  <span className="inline-flex items-center rounded-full bg-[#fff5e6] px-3.5 py-1.5 text-[13px] text-[#92580f]">
                    <CircleAlert className="mr-2 size-3.5 text-[#d18d2c]"/>
                    Selecting "Top tier" raises base rates by 30%.
                  </span>
                }
              />
              {this.state.curriculumOther ?
                <div className="inline-block">
                  <Input className="h-8 w-[140px]" defaultValue={lesson_plan.tutoring_job.curriculum || ''} onBlur={(e) => this.onCurriculumChange(e.target.value)} autoFocus placeholder="Curriculum..." />
                </div>
              :
                <PillSelect
                  icon={Book}
                  options={this.getCurriculumOptions()}
                  value={this.getCurriculumSelectValue()}
                  placeholder="Select Syllabus"
                  onChange={this.onCurriculumSelectChange}
                  footer={
                    <span className="inline-flex items-center rounded-full bg-[#fff5e6] px-3.5 py-1.5 text-[13px] text-[#92580f]">
                      <Wrench className="mr-2 size-3.5 text-[#d18d2c]"/>
                      Curriculum filtering is a work in progress.
                    </span>
                  }
                />
              }
              <PillSelect
                icon={Handshake}
                options={commitmentOptions}
                value={lesson_plan.tutoring_job.commitment}
                placeholder="Commitment..."
                onChange={this.onCommitmentChange}
              />
              <DateSelect
                icon={Calendar}
                value={lesson_plan.tutoring_job.start_date || ''}
                placeholder="Start date..."
                displayPrefix="Start: "
                onChange={this.onStartDateChange}
                immediate
              />
              <PillSelect
                icon={Zap}
                options={urgencyOptions}
                displayMap={urgencyDisplay}
                value={lesson_plan.tutoring_job.urgency}
                placeholder="Urgency..."
                onChange={this.onUrgencyChange}
              />
              <PillSelect
                icon={CircleHelp}
                options={challengeOptions}
                displayMap={challengeDisplay}
                value={lesson_plan.tutoring_job.settings && lesson_plan.tutoring_job.settings.challenge}
                placeholder="Challenge..."
                onChange={this.onChallengeChange}
              />
            </div>
            <ClientAvailability
              enquiry_id={this.props.enquiry_id}
              lesson_plan_id={lesson_plan.id}
              availability={lesson_plan.tutoring_job.availability}
            />
          </CardContent>
        </Card>
        <TutorResults
          tutoring_job={this.props.tutoring_job}
          tutor_results={this.props.tutor_results}
          tutor_proposals={this.props.tutor_proposals}
          ui={this.props.ui}
        />
        {this.state.jobAdConfirmOpen &&
          <Modal title="Turn Job Ad on?" size="modal-lg" onClose={this.onJobAdCancel}>
            <div className="p-6">
              <div className="mb-4">
                <JobReadiness lesson_plan={lesson_plan} />
              </div>
              <p className="text-muted-foreground mb-4 text-[13px]">
                Once on, tutors browsing the job board will see this ad with the choices above. You can turn it off again at any time.
              </p>
              <div className="flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={this.onJobAdCancel}>Cancel</Button>
                <Button variant="success" size="sm" onClick={this.onJobAdConfirm}>Turn on</Button>
              </div>
            </div>
          </Modal>
        }
      </React.Fragment>
    )
  }
}

export default LessonPlanTutors
